package com.essntl.core.whatsapp.data.response

import com.essntl.features.message.domain.model.GroupParticipantModel
import kotlinx.serialization.Serializable

@Serializable
data class GroupParticipantDto(
    val id: String,
    val rank: String,
) {
    fun toModel(): GroupParticipantModel =
        GroupParticipantModel(
            id = id,
            rank = rank,
        )
}
